import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import * as Icons from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { BRANCHEN_LIST } from "../data/branchen";
import { IMAGES } from "../data/content";

export default function BranchenOverview() {
  const schema = {
    "@context": "https://schema.org", "@type": "ItemList",
    itemListElement: BRANCHEN_LIST.map((b, i) => ({
      "@type": "ListItem", position: i + 1, name: `Energieberatung ${b.name}`,
      url: `https://www.energie-tarifberater.de/branche/${b.slug}`,
    })),
  };
  return (
    <>
      <Seo title="Branchenlösungen – Energieberatung nach Branche"
        description="Branchenspezifische Energieberatung: Hotels, Gastronomie, Praxen, Hausverwaltungen, Industrie, Handwerk und mehr. Typische Einsparpotenziale unabhängig geprüft."
        path="/branchen" schema={schema} />
      <PageHero eyebrow="Für Ihre Branche" titleLines={["Energie, die zu Ihrer", 'Branche <span class="font-serif italic text-blue-700">passt.</span>']}
        subtitle="Jede Branche hat eigene Verbrauchsprofile und Kostentreiber. Wir analysieren individuell – von Hotels bis zur Industrie."
        breadcrumb={[{ label: "Gewerbekunden", to: "/gewerbekunden" }, { label: "Branchen" }]} />
      <section className="bg-background py-24 sm:py-32">
        <div className="max-w-[1400px] mx-auto px-6 sm:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {BRANCHEN_LIST.map((b, i) => {
            const Icon = Icons[b.icon] || Icons.Building2;
            return (
              <Reveal key={b.slug} delay={(i % 3) * 0.08}>
                <Link to={`/branche/${b.slug}`} className="group block h-full rounded-3xl border border-slate-200 bg-white p-8 hover:-translate-y-1.5 hover:border-blue-300 hover:shadow-[0_30px_60px_-35px_rgba(29,78,216,0.25)] transition-[transform,border-color,box-shadow] duration-500" data-testid={`branchen-card-${b.slug}`}>
                  <div className="flex items-center justify-between mb-6">
                    <span className="inline-grid place-items-center h-14 w-14 rounded-2xl bg-blue-50 text-blue-700 group-hover:bg-blue-700 group-hover:text-white transition-colors duration-500"><Icon className="h-6 w-6" /></span>
                    <ArrowUpRight className="h-5 w-5 text-slate-300 group-hover:text-blue-700 transition-colors" />
                  </div>
                  <h3 className="text-xl font-heading text-navy-900 mb-2">{b.name}</h3>
                  <p className="text-slate-500 text-sm leading-relaxed">{b.intro("").slice(0, 120)}…</p>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </section>
    </>
  );
}
